
























import { Component, Vue } from 'vue-property-decorator'
import Axios from 'axios'

@Component
export default class Carousel extends Vue {
  private items: any
  private test: any

  constructor() {
    super()

    this.items = [
      {
        src: '/assets/img/carrossel/3.jpeg'
      }
    ]

    this.test = []
      
    this.carregar();
    
  
  }

  async carregar() {

    const requests = [];

    for (let i = 1; i < 5; i++) {
      const request = Axios.head(`/assets/img/carrossel/${i}.png`)
      .then(res => {
        if (res.headers['content-type'] === 'image/png')
          return { src: `/assets/img/carrossel/${i}.png` };
        
        return null;
      })
      .catch(error => {
        console.error(error);
      })
    
      requests.push(request);
    }
  
    const results = await Promise.all(requests);
    this.test = results.filter(result => result !== null);
    console.log(this.test[0].src);
    console.log(this.test[1].src);
  }

}
